const items = [
  { icon: '🔩', label: 'Tornillos y tuercas' },
  { icon: '🔨', label: 'Herramientas manuales' },
  { icon: '🎨', label: 'Pinturas y recubrimientos' },
  { icon: '🛡️', label: 'Equipo de seguridad' },
  { icon: '⚙️', label: 'Electrodos para soldadura' },
  { icon: '💿', label: 'Abrasivos y discos de corte' },
  { icon: '🪝', label: 'Bisagras y cerrajería' },
  { icon: '🧱', label: 'Materiales de construcción' },
];

export default function Ferreteria() {
  return (
    <section className="ferreteria">
      <div className="container">
        <div className="ferreteria-grid">
          <div className="ferreteria-text">
            <span className="about-badge">⚙ Servicio adicional</span>
            <h2 className="about-title" style={{ marginTop: '12px' }}>
              También contamos con<br />
              <span>Ferretería</span>
            </h2>
            <p className="about-text">
              Herreros, soldadores y contratistas encuentran en Aceros Jalos algo
              más que materia prima: también los consumibles y herramientas para
              transformarla. Electrodos, discos de corte, abrasivos, pinturas,
              tornillería y equipo de seguridad — todo bajo el mismo techo.
            </p>
            <p className="about-text">
              Todo en un solo lugar: acero y ferretería en Jalostotitlán, Jalisco.
            </p>
            <button
              className="btn btn-primary"
              style={{ marginTop: '8px' }}
              onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Consultar disponibilidad
            </button>
          </div>

          <div className="ferreteria-items">
            {items.map(({ icon, label }) => (
              <div key={label} className="ferreteria-item">
                <span className="ferreteria-item-icon">{icon}</span>
                <span className="ferreteria-item-label">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
